import styles from './CheckOutVisitDialog.module.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import moment, { Moment } from 'moment-timezone';

import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';

import BlockUi from 'react-block-ui';
import { HealAPI } from '../../../healApi';
import { ToastParams } from '../../../redux/message/types';
import { Visit } from '../../../redux/visits/types';
import { DateTimePicker } from '../../core/DateTimePicker';

export interface CheckOutVisitDialogProps {
  visit: Visit;
  onClosed?: (success: boolean) => void;
  actions: {
    toast: (params: ToastParams) => void;
  };
}

export interface CheckOutVisitDialogState {
  isSaving: boolean;
  datetime: Moment;
}

export class CheckOutVisitDialog {
  public static show(options: CheckOutVisitDialogProps) {
    const dialogNode = document.createElement('div');
    const close = (): void => {
      ReactDOM.unmountComponentAtNode(dialogNode);
      dialogNode.remove();
    };
    ReactDOM.render(<CheckOutVisitDialogInternal {...options} close={close} />, dialogNode);
  }
}

class CheckOutVisitDialogInternal extends React.Component<CheckOutVisitDialogProps & { close: () => void }, CheckOutVisitDialogState> {
  constructor(props: CheckOutVisitDialogProps & { close: () => void }) {
    super(props);
    this.state = {
      isSaving: false,
      datetime: moment(),
    };
  }

  public render(): JSX.Element {
    return (
      <Dialog
        hidden={false}
        className="checkout-visit-dialog"
        modalProps={{
          className: styles.checkOuVisitDialog,
          isBlocking: true,
        }}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: 'Checkout visit: ' + this.props.visit.visitCode,
          subText: `Timezone: ${this.props.visit.timezone}`,
        }}
        onDismiss={() => this.close()}
      >
        <BlockUi tag="div" blocking={this.state.isSaving}>
          <DateTimePicker label="Set the end time" required={true} value={this.state.datetime} onChange={(m) => this.setState({ datetime: m })} />

          <DialogFooter>
            <PrimaryButton onClick={this.onCheckOut} disabled={this.state.isSaving}>
              Ok
            </PrimaryButton>
            <DefaultButton onClick={() => this.close()}>Cancel</DefaultButton>
          </DialogFooter>
        </BlockUi>
      </Dialog>
    );
  }

  private close = (success = false) => {
    if (this.props.onClosed) {
      this.props.onClosed(success);
    }
    this.props.close();
  };

  private onCheckOut = () => {
    this.setState({ isSaving: true });
    HealAPI.checkOutVisit(this.props.visit.visitCode, this.state.datetime.toDate()).then((response) => {
      this.setState({ isSaving: false });
      if (response.ok) {
        this.close(true);
      }
    });
  };
}
